const orderConstants = {
  ORDER_CREATE_REQUEST: 'ORDER_CREATE_REQUEST',
  ORDER_CREATE_SUCCESS: 'ORDER_CREATE_SUCCESS',
  ORDER_CREATE_FAIL: 'ORDER_CREATE_FAIL',

  ORDER_DETAILS_REQUEST: 'ORDER_DETAILS_REQUEST',
  ORDER_DETAILS_SUCCESS: 'ORDER_DETAILS_SUCCESS',
  ORDER_DETAILS_FAIL: 'ORDER_DETAILS_FAIL',

  ORDER_PAYMENT_SUCCESS: 'ORDER_PAYMENT_SUCCESS',
  ORDER_PAYMENT_FAIL: 'ORDER_PAYMENT_FAIL',

  
  GET_ALL_MY_ORDERS_REQUEST: 'GET_ALL_MY_ORDERS_REQUEST',
  GET_ALL_MY_ORDERS_SUCCESS: 'GET_ALL_MY_ORDERS_SUCCESS',
  GET_ALL_MY_ORDERS_FAIL: 'GET_ALL_MY_ORDERS_FAIL',
};

export default orderConstants;
